import React from 'react';

import RoundedButton from '@components/RoundedButton';

import { PdfControlsBar } from './PdfExport.styles';

interface PdfPrintControlsProps {
  onBack: () => void;
  /** Label for the Back button. */
  backLabel: string;
  /** Label for the Print / Save PDF button (must be translated by the caller). */
  printLabel: string;
  /** Custom print handler. Defaults to `window.print()`. */
  onPrint?: () => void;
}

/**
 * Sticky bar with Back and Print/Save PDF buttons.
 * Hidden via `@media print` — never appears in the printed output.
 */
export default function PdfPrintControls({
  onBack,
  backLabel,
  printLabel,
  onPrint,
}: PdfPrintControlsProps) {
  return (
    <PdfControlsBar>
      <RoundedButton autoSize onClick={onBack} variant="grey">
        {backLabel}
      </RoundedButton>
      <RoundedButton
        autoSize
        onClick={onPrint ?? (() => window.print())}
        variant="blue"
      >
        {printLabel}
      </RoundedButton>
    </PdfControlsBar>
  );
}
